import { render, staticRenderFns } from "./CategoryOptionConfirm.vue?vue&type=template&id=ff8170e8&scoped=true"
import script from "./CategoryOptionConfirm.vue?vue&type=script&lang=ts"
export * from "./CategoryOptionConfirm.vue?vue&type=script&lang=ts"
import style0 from "./CategoryOptionConfirm.vue?vue&type=style&index=0&id=ff8170e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8170e8",
  null
  
)

export default component.exports